export default {"src":"/_next/static/media/new-avatar.55f5570d.svg","height":31,"width":30};